import { faTrophy } from '@fortawesome/free-solid-svg-icons';
import type { JSX } from 'react';

import TimelineHeader from '@/pages/Timeline/components/TimelineHeader/TimelineHeader';
import TimestampAndActor from '@/pages/Timeline/components/TimestampAndActor/TimestampAndActor';
import { TimelineSubcomponentProps } from '@/pages/Timeline/types';
import Card from '@/ui/components/Card';

/*
{
  "backfill": false,
  "celebrate": true,
  "earned_at": "2024-12-04T18:26:49.938+00:00",
  "person_id": "ba8b569c-0499-49df-9647-bc0640126e28",
  "achievement_title": "8 Tracked",
  "celebration_title": "Locked in",
  "celebration_action": "SHARE",
  "detailed_asset_url": "https://affect-assets.s3.amazonaws.com/achievements/staging/days-tracked/8-tracked/8-tracked.json",
  "shareable_asset_url": "https://affect-assets.s3.amazonaws.com/achievements/staging/days-tracked/8-tracked/8-tracked-share.jpg",
  "person_achievement_id": "060672d5-de7a-4452-8420-3ec1627b08dd",
  "celebration_description": "8 days of use or sobriety tracked! \r\n\r\nYou're building the foundation for lasting change. Keep the momentum going—your progress is already shining through!\r\n\r\nYour next tracking achievement: 14 Days",
  "achievement_category_name": "Days Tracked",
  "celebration_rich_description": "<p>8 days of use or sobriety tracked!</p>\r\n<p>You're building the foundation for lasting change. Keep the momentum going—your progress is already shining through!</p>\r\n\r\n<p><b>Your next tracking achievement:</b>  14 Days</p>"
}
*/

const PersonAchievementEvent = ({ activityLog }: TimelineSubcomponentProps): JSX.Element => {
  const { actor, data, timestamp } = activityLog;

  return (
    <div>
      <Card>
        <TimelineHeader
          icon={faTrophy}
          iconClassName="text-emerald-700"
          subtitle={data?.celebration_description}
          title={`${data?.achievement_category_name} -- ${data?.achievement_title}`}
        />
      </Card>

      <TimestampAndActor actor={actor} timestamp={timestamp} />
    </div>
  );
};

export default PersonAchievementEvent;
